import { render, staticRenderFns } from "./ProductSizes.vue?vue&type=template&id=30ecfc74&scoped=true&"
import script from "./ProductSizes.vue?vue&type=script&lang=js&"
export * from "./ProductSizes.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizes.vue?vue&type=style&index=0&id=30ecfc74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ecfc74",
  null
  
)

export default component.exports